<div [ngClass]="showIcon && status" class="d-flex align-items-center w-100">
  <i *ngIf="showIcon" class="icon xs" [class]="'i-'+ status" ></i>
  <div class=" ellipsis label" *ngIf="showLabel">{{EXPERIMENTS_STATUS_LABELS[status]}}</div>
</div>
